module.exports = __webpack_public_path__ + "media/klaseaDia3k2500.2ce4c963.mp4";